import { types } from "../../types/types";
import { RECETAS_ESTADOS } from "../../utils/constants";

const initialState = {
  activeStep: 0,
  afiliadoSeleccionado: null,
  estadoRecetas: RECETAS_ESTADOS.EN_CARGA?.toString(),
  medicamentos: [],
  showForm: true,
  recetas: [],
  recetasContadores: [],
  recetaSeleccionada: null,
  recetaSeleccionadaSeguimiento: null,
  tipoRecetasDigitales: [],
  provinciasCSF: [],
  subtipoRecetasDigitales: []
};

export const RecetasDigitalesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.recetasDigitalesClearReducer:
      return {
        ...initialState,
      };
    case types.recetasDigitalesUpdateEstadoRecetas:
      return {
        ...state,
        estadoRecetas: action.payload,
      };
    case types.recetasDigitalesSetStep:
      return {
        ...state,
        activeStep: action.payload,
      };
    case types.recetasDigitalesSetAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: action.payload,
      };
    case types.recetasDigitalesCleanAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: null,
      }
    case types.recetasDigitalesUpdateAfiliadoSeleccionado:
      return {
        ...state,
        afiliadoSeleccionado: action.payload,
      };
    case types.recetasDigitalesGetTiposRecetasSuccess:
      return {
        ...state,
        tipoRecetasDigitales: action.payload,
      };
    case types.recetasDigitalesGetTiposRecetasError:
      return {
        ...state,
        tipoRecetasDigitales: [],
      };
    case types.recetasDigitalesGetSubtiposRecetasSuccess:
      return {
        ...state,
        subtipoRecetasDigitales: action.payload,
      };
    case types.recetasDigitalesGetSubtiposRecetasError:
      return {
        ...state,
        subtipoRecetasDigitales: [],
      };
    case types.recetasDigitalesGetRecetasSuccess:
      return {
        ...state,
        recetas: action.payload,
      };
    case types.recetasDigitalesCleanRecetas:
      return {
        ...state,
        recetas: [],
      };
    case types.recetasDigitalesAnularRecetasSuccess:
      return {
        ...state,
        recetas: state.recetas.filter(item => item.idRecetaDigital !== action.payload)
      };
    case types.recetasDigitalesGetRecetasError:
      return {
        ...state,
        recetas: [],
      };
    case types.recetasDigitalesGetContadoresRecetasSuccess:
      return {
        ...state,
        recetasContadores: action.payload,
      };
    case types.recetasDigitalesGetContadoresRecetasError:
      return {
        ...state,
        recetasContadores: [],
      };
    case types.recetasDigitalesAddMedicamento:
      const medicamentosAux = Array.isArray(state.medicamentos)
        ? [...state.medicamentos]
        : [];
      return {
        ...state,
        medicamentos: [...medicamentosAux, action.payload],
      };
    case types.recetasDigitalesSetRecetaSeleccionadaMedicamentos:
      return {
        ...state,
        medicamentos: action.payload
      };
    case types.recetasDigitalesSetRecetaSeleccionada:
      return {
        ...state,
        recetaSeleccionada: action.payload,
      };
    case types.recetasDigitalesSetShowForm:
      return {
        ...state,
        showForm: action.payload,
      };
    case types.recetasDigitalesSetMedicamentos:
      return {
        ...state,
        medicamentos: action.payload,
      };
    case types.recetasDigitalesGetMedicamentosSuccess:
      return {
        ...state,
        medicamentos: action.payload,
      };
    case types.recetasDigitalesUpdateRecetaSeleccionada:
      return {
        ...state,
        recetaSeleccionada: action.payload,
      };
    case types.traerProvinciasCSFSuccess:
      return {
        ...state,
        provinciasCSF: action.payload,
      };
    case types.traerProvinciasCSFError:
      return {
        ...state,
        provinciasCSF: [],
      };
    default:
      return state;
  }

};
